import { apiClient } from '../../../../helpers/api_helper';

export const GetPurchaseOrderRequestList = async (data:object) => {
    try {
        const response = await apiClient.get(`/api/v1/PurchaseOrder/GetPurchaseOrderRequestList`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const GetOldGoldPurchaseOrderItemListByBagId = async (id: string) => {
    try {
        const response = await apiClient.get(`/api/v1/PurchaseOrder/GetOldGoldPurchaseOrderItemListByBagId?bagId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const GenerateDeliveryChallan = async (id: string) => {
    try {
        const response = await apiClient.get(`/api/v1/PurchaseOrder/GenerateDeliveryChallan?bagId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }

};

export const UpdateMayavePurchaseOrderRate = async (data: any) => {
    try {
        const response = await apiClient.post(`/api/v1/PurchaseOrder/UpdateMayavePurchaseOrderRate`, data)
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const GetTodayMayaveGoldRate = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/GoldRateMaster/GetTodaysGoldRateMaster?ktId=${id}`)
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const GenerateEstimatePaymentReceipt = async (data:any) => {
    try {
         const response = await apiClient.get(`api/v1/PurchaseOrder/GenerateEstimatePaymentReceipt?bagId=${data}`)
         return response;
    } catch (error: any) {
        throw new Error(error.message);
        
    }
}

export const UpdateMayavePurchaseOrderStatus= async (params: any ) => {
    try {
        const response = await apiClient.post(`api/v1/PurchaseOrder/UpdateMayavePurchaseOrderStatus`,params)
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const GeneratePurchaseOrderInvoice= async (data: any ) => {
    try {
        const response = await apiClient.get(`/api/v1/PurchaseOrder/GeneratePurchaseOrderInvoice?bagId=${data}`)
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}